module.exports = require('./src/index');


/*****************
 ** WEBPACK FOOTER
 ** ../~/http-memoizr/index.js
 ** module id = 532
 ** module chunks = 0
 **/